import type { IconProps } from './types/types';

const YotpoIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 23C18.0752 23 23 18.0752 23 12C23 5.92486 18.0752 1 12 1C5.92486 1 1 5.92486 1 12C1 18.0752 5.92486 23 12 23Z"
      fill="#0042E4"
    />
    <path
      d="M12.3438 11.0627L10.3099 5.125H7.1875L10.8649 14.6144L9.33484 18.875H12.327L17.5 5.125H14.4749L12.3438 11.0627Z"
      fill="white"
    />
  </svg>
);

export default YotpoIcon;
